module.exports = __webpack_public_path__ + "img/qualityJewellery@2x.12f3c47.webp";